import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

class SaveModelAssignment {
	constructor(
		public readonly scope: AssignmentScope,
		// Bare enum value (`interview_transcription`, …): it travels in the URL, never in the body.
		public readonly usage: string,
		public readonly modelId: number | null,
	) {
		Object.freeze(this);
	}

	// `modelId` is never omitted: `null` saves a level that switches a live usage off.
	// `usage` is already in the URL: repeating it here would fail `forbidNonWhitelisted`.
	toJSON(): Record<string, unknown> {
		return {
			modelId: this.modelId,
		};
	}
}

export default SaveModelAssignment;
